<div class="section-title">
  {{ text }}

  <mat-checkbox
    *ngIf="displayCarryOverFilter"
    (change)="onShowCarryOverChange()"
    [(ngModel)]="filterOnlyCarryOver"
    color="primary"
    class="carry-over-checkbox"
  >
    show carry-over only
  </mat-checkbox>
  <mat-icon
    *ngIf="showExpansionIndicator"
    [@rotatedState]="expanded ? 'rotated' : 'default'"
    svgIcon="cvx-right"
    class="expansion-indicator"
    (click)="onExpansionClick()"
  ></mat-icon>
</div>

<app-separator></app-separator>
